import { frankfurtTitles } from '@/mocks/frankfurt2026';

export default function FeaturedTitles() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
      {frankfurtTitles.map((item, index) => (
        <div
          key={item.title}
          className="group bg-cream-50 rounded-2xl border border-cream-200 p-5 md:p-6 hover:border-gold-300 transition-colors duration-500"
        >
          <div className="flex items-start justify-between gap-3 mb-4">
            <div className="w-11 h-11 rounded-xl bg-gold-100 flex items-center justify-center shrink-0 transition-colors duration-500 group-hover:bg-gold-400">
              <i className="ri-bookmark-3-line text-gold-700 text-lg transition-colors duration-500 group-hover:text-navy-900"></i>
            </div>
            <span className="text-2xl font-bold text-cream-300 leading-none">
              {String(index + 1).padStart(2, '0')}
            </span>
          </div>
          <h4 className="text-base font-bold text-navy-900 leading-snug mb-1">{item.title}</h4>
          {item.author ? (
            <p className="text-xs font-medium text-gold-700 mb-3">{item.author}</p>
          ) : (
            <p className="text-xs font-medium text-navy-400 mb-3">Leavitt Peak Press</p>
          )}
          <p className="text-sm text-navy-600 leading-relaxed">{item.note}</p>
        </div>
      ))}
    </div>
  );
}